import { computed, effect, Injectable } from '@angular/core';
import { KopConfigService } from './kop-config.service';
import { HwdConfigService } from '../kanaal/hwd-config.service';
import { JSBridgeService } from './jsbridge.service';
import { KopModulesService } from '../modules/kop-modules.service';

@Injectable({
  providedIn: null
})
export class AutosaveService {

  constructor(private kopConfigService: KopConfigService, private hwdConfigService: HwdConfigService, 
        private jsBridgeService: JSBridgeService, private kopModulesService: KopModulesService) {
    let _self = this;
    window.onbeforeunload =  function(event) {
      if (_self.isDirty()) {
        event.preventDefault();
        return event;

      }
    };
    setInterval(async () => {
      if (_self.isDirty()) {
        // SXB
        let data = await _self.jsBridgeService.save(false);
        let dataBase64 = btoa(String.fromCharCode.apply(null, data));
        let klantNo = this.jsBridgeService.getKlantNo();

        window.localStorage.setItem(`${klantNo}.SXB`, dataBase64);

        //JSON
        let json = this.kopModulesService.serialize();
        window.localStorage.setItem(`${klantNo}.modules.json`, json);

      } else {
        _self.clearAutosave();
      }
    }, 5000);

    effect(() => {
      let isDirty = this.isDirty();
      if (!isDirty) {
        this.clearAutosave();
      }
    });
  }

  public clearAutosave() {
    let klantNo = this.jsBridgeService.getKlantNo();
    window.localStorage.removeItem(`${klantNo}.SXB`);
    window.localStorage.removeItem(`${klantNo}.modules.json`);
  }

  public isDirty = computed(() => {
    let isKopDirty = this.kopConfigService.isDirty();
    let isHwdDirty = this.hwdConfigService.isDirty();
    return isKopDirty || isHwdDirty;
  });
}
